<div class="flex flex-middle">
  @for (option of size.getOptions(); track option) {
    <button
      [ngClass]="'icon-grid-' + option.size + (size.isSelected(option) ? '-fill' : '')"
      [class.col-4]="!size.isSelected(option)"
      aria-hidden="true"
      class="col-1 m-l-3 inline-flex"
      role="button"
    (click)="size.setState(option.size)"></button>
  }
</div>